<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :apiUrl="apiUrl">

      <template #additionalButton="scope">
        <button
          class="btn btn-sm btn-primary btn-icon-split"
          v-b-tooltip.hover
          title="Cetak Kontrak"
          @click="onPrintAssignment">
          <span class="icon">
            <i class="fas fa-print" />
          </span>
          <span class="text d-none d-lg-inline-block">Cetak Kontrak</span>
        </button>
      </template>

      <template #form="scope">
        <div class="row">
          <div class="col">
            <div class="form-group input-group-sm">
              <label>Nomor SK</label>
              <input class="form-control d-block w-100" v-model="scope.data.ContractNumber">
            </div>

            <div class="form-group">
              <label>Mulai Kontrak</label>
              <b-form-datepicker v-model="scope.data.Start" locale="id" size="sm" />
            </div>

            <div class="form-group">
              <label>Akhir Kontrak</label>
              <b-form-datepicker v-model="scope.data.End" locale="id" size="sm" />
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label>Status</label>
              <v-select
                v-model="scope.data.EmployeeAssignmentTypeID"
                :options="listEmployeeAssignmentTypes"
                :reduce="item => item.ID"
                label="Name"/>
            </div>

            <div class="form-group">
              <label>Jabatan</label>
              <v-select
                v-model="scope.data.PositionID"
                :options="listPositions"
                :reduce="item => item.ID"
                label="Name"/>
            </div>

            <div class="form-group">
              <label>Departemen</label>
              <v-select
                v-model="scope.data.DepartmentID"
                :options="listDepartments"
                :reduce="item => item.ID"
                label="Name"/>
            </div>
          </div>
        </div>

        <div class="text-right">
          <button type="submit" class="btn btn-sm btn-primary">Simpan</button>
        </div>
      </template>
    </AppToolbox>

    <AppTable
      :apiUrl="`${apiUrl}/get-employee/${this.$route.params.id}`"
      :fields="tableFields"
      :search="search"
      @onSelectItem="selectedItem = $event" />

    <b-modal id="modalPrint" hide-footer no-close-on-backdrop size="lg" title="Cetak Kontrak" header-class="bg-light text-primary py-1">
      <iframe ref="printFrame" id="printFrame" class="w-100" height="600" name="printFrame"></iframe>

      <div class="text-center">
        <button class="btn btn-primary" @click="onPrint">Print</button>
      </div>
    </b-modal>

  </div>

</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.fetchOptionData()

    this.scopedFormData.EmployeeID = parseInt(this.$route.params.id)
  },
  data() {
    return {
      apiUrl: '/employee-assignment',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'ContractNumber', label: 'Nomor SK' },
        { key: 'Position', label: 'Jabatan', formatter: value => value.Name },
        { key: 'Department', label: 'Ruang', formatter: value => value.Name },
        { key: 'EmployeeAssignmentType', label: 'Status', formatter: value => value.Name },
        { key: 'Start', label: 'Mulai Kontrak', formatter: value => this.$helper.formatDate(value) },
        { key: 'End', label: 'Akhir Kontrak', formatter: value => this.$helper.formatDate(value) }
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {
        ID: null,
        // EmployeeID: null,
        ContractNumber: '',
        PositionID: null,
        DepartmentID: null,
        EmployeeAssignmentTypeID: null,
        Start: (new Date()),
        End: (new Date())
      },
      listPositions: [],
      listDepartments: [],
      listEmployeeAssignmentTypes: [],
      director: null
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    fetchOptionData () {
      this.$axios.all([
        this.$axios.get('/position'),
        this.$axios.get('/department'),
        this.$axios.get('/employee-assignment-type'),
        this.$axios.get('/employee?positionId=117') // direktur
      ]).then(this.$axios.spread((...res) => {
        this.listPositions = res[0].data
        this.listDepartments = res[1].data
        this.listEmployeeAssignmentTypes = res[2].data
        this.director = res[3].data[0]
      }))
    },
    onPrintAssignment () {
      console.log(this.selectedItem)

      const employeeLastEducation = this.selectedItem ? this.selectedItem.Employee.EmployeeEducations[0] : null

      const employeeCurrentPosition = this.selectedItem ? this.selectedItem.Position : null

      const employeeSalary = (employeeCurrentPosition.SalaryPricings.filter(obj => obj.EducationID === employeeLastEducation.EducationID))[0].Price

      const dateFormatOption = { year: 'numeric', month: 'long', day: 'numeric' }

      const startTraining = (new Date(this.selectedItem.Start))
      startTraining.setDate(1)
      startTraining.setMonth(startTraining.getMonth()-2)
      const formatedStartTraining = startTraining.toLocaleString('id-ID', dateFormatOption)

      const endTraining = (new Date(startTraining.getFullYear(), startTraining.getMonth() + 3, 0))
      const formatedEndTraining = endTraining.toLocaleString('id-ID', dateFormatOption)

      const formatedStartTrial = (new Date(this.selectedItem.Start)).toLocaleString('id-ID', dateFormatOption)
      const formatedEndTrial = (new Date(this.selectedItem.End)).toLocaleString('id-ID', dateFormatOption)


      this.$bvModal.show('modalPrint')

      const content = `
        <h2 class="text-center">PEMERINTAH KABUPATEN LAMONGAN</h2>
        <h2 class="text-center">RUMAH SAKIT UMUM DAERAH Dr. SOEGIRI</h2>
        <h4 class="text-center">Jl. Kusuma Bangsa No. 7 Lamongan Kode Pos : 62214</h4>
        <h4 class="text-center">Telp. (0322) 321718, 322582, Fax (0322) 322582</h4>
        <h4 class="text-center">E-Mail : <u>rsud-soegiri@lamongankab.go.id</u> Website <u>www.lamongankab.go.id/rsud-soegiri</u></h4>

        <br>

        <div class="text-center">
          <h2>SURAT PERJANJIAN KONTRAK KERJA</h2>
          <h2><u>PADA RSUD Dr. SOEGIRI KABUPATEN LAMONGAN</u></h2>

          <p>
            NOMOR : 800 / ..... / 413.209 / ${(new Date).getFullYear()}
          </p>
        </div>

        <p>Yang bertanda tangan dibawah ini :</p>
        <table border="0">
        <tr>
          <td>Nama</td>
          <td> : </td>
          <td>
            ${this.director.FrontDegree}
            ${this.director.Name}
            ${this.director.RearDegree}
          </td>
        </tr>
        <tr>
          <td>NIP</td>
          <td> : </td>
          <td>${this.director.EmployeeIdNumber}</td>
        </tr>
        <tr>
          <td>Pangkat/Golongan</td>
          <td> : </td>
          <td>${this.director.EmployeeClass.Alias} - ${this.director.EmployeeClass.Name}</td>
        </tr>
        </table>
        <p>Yang selanjutnya disebut PIHAK PERTAMA</p>

        <table border="0">
        <tr>
          <td>Nama</td>
          <td> : </td>
          <td>${this.selectedItem ? this.selectedItem.Employee.Name : ''}</td>
        </tr>
        <tr>
          <td>NIK</td>
          <td> : </td>
          <td>${this.selectedItem ? this.selectedItem.Employee.NationalIdentityNumber : ''}</td>
        </tr>
        <tr>
          <td>Tempat/Tgl. Lahir</td>
          <td> : </td>
          <td>
            ${this.selectedItem ? this.selectedItem.Employee.PlaceOfBirth : ''} / 
            ${this.selectedItem ? this.$helper.formatDate(this.selectedItem.Employee.DateOfBirth) : ''}
          </td>
        </tr>
        <tr>
          <td>Pendidikan/Tahun Lulus</td>
          <td> : </td>
          <td>
            ${employeeLastEducation ? employeeLastEducation.StudyProgram : ''}
            di ${employeeLastEducation ? employeeLastEducation.University : ''}
            / ${employeeLastEducation ? this.$helper.formatDate(employeeLastEducation.End) : ''}
          </td>
        </tr>
        <tr>
          <td>Alamat</td>
          <td> : </td>
          <td>
            ${this.selectedItem ? this.selectedItem.Employee.Address : ''}
          </td>
        </tr>
        <tr>
          <td>TMT Awal</td>
          <td> : </td>
          <td>
            ${this.selectedItem ? this.$helper.formatDate(this.selectedItem.Start) : ''}
          </td>
        </tr>
        </table>
        <p>Yang selanjutnya disebut PIHAK KEDUA</p>

        <br>

        <h4 class="text-center">Pasal 1</h4>
        <p style="text-indent: 50px; text-align: justify;">
        PIHAK PERTAMA karena jabatannya mengangkat/menugaskan kepada PIHAK KEDUA untuk melaksanakan tugas/pekerjaan pada RSUD Dr. Soegiri Kabupaten Lamongan dan PIHAK KEDUA menerima dan bersedia melaksanakan tugas yang diberikan PIHAK PERTAMA, yang ditugaskan sebagai <strong>${employeeCurrentPosition ? employeeCurrentPosition.Name : ''}</strong> di RSUD Dr. Soegiri Kabupaten Lamongan.
        </p>

        <h4 class="text-center">Pasal 2</h4>
        <p style="text-indent: 50px; text-align: justify;">
        PIHAK KEDUA harus mematuhi dan melaksanakan kewajiban yang diberikan oleh PIHAK PERTAMA sebagaimana yang berlaku bagi Pegawai Negeri Sipil.
        </p>

        <h4 class="text-center">Pasal 3</h4>
        <p style="text-indent: 50px; text-align: justify;">
        PIHAK KEDUA berkewajiban untuk mengikuti orientasi pegawai sebagaimana ketentuan yang berlaku untuk calon pagawai baru, mulai <strong>${formatedStartTraining}</strong> sampai dengan <strong>${formatedEndTraining}</strong> dan selama orientasi PIHAK KEDUA belum menjadi pegawai kontrak RSUD Dr. Soegiri dan tidak menerima honorarium dan atau penghasilan lainya.
        </p>

        <h4 class="text-center">Pasal 4</h4>
        <p style="text-indent: 50px; text-align: justify;">
        PIHAK KEDUA setelah menyelesaikan masa orientasi, dilanjutkan dengan masa percobaan sebagai pegawai kontrak RSUD Dr. Soegiri selama 3 (tiga) bulan terhitung mulai tanggal <strong>${formatedStartTrial}</strong> berakhir <strong>${formatedEndTrial}</strong> sehingga PIHAK KEDUA berhak menerima honorarium sebesar <strong>${this.$helper.formatRupiah(employeeSalary)}</strong> (${this.$helper.terbilang(employeeSalary)}) setiap bulannya dan atau penghasilan lainnya.
        </p>

        <h4 class="text-center">Pasal 5</h4>
        <p style="text-indent: 50px; text-align: justify;">
        Perjanjian kontrak kerja diperpanjang dengan pertimbangan presentasi yang bersangkutan dan apabila tidak diperpanjang lagi masa kontrak kerja, maka PIHAK KEDUA tidak berhak menuntut pesangon dan sejenisnya kepada PIHAK PERTAMA
        </p>

        <h4 class="text-center">Pasal 6</h4>
        <p style="text-indent: 50px; text-align: justify;">
        Apabila berdasarkan evaluasi PIHAK PERTAMA, PIHAK KEDUA dianggap tidak mampu dan atau tidak melaksanakan tugasnya sesuai ketentuan yang berkalaku, maka perjanjuan ini dianggap gugur atau perjanjian tidak diperpanjang lagi.
        </p>

        <h4 class="text-center">Pasal 7</h4>
        <p style="text-indent: 50px; text-align: justify;">
        PIHAK KEDUA dapat mengajukan perpanjangan perjanjian kerja dengan membuat permohonan kepada Direktur RSUD Dr. Soegiri Kabupaten Lamongan 1 (satu) bulan sebelum masa kontraknya berakhir.
        </p>

        <h4 class="text-center">Pasal 8</h4>
        <p style="text-indent: 50px; text-align: justify;">
        Perjanjian kerja gugur apabila PIHAK KEDUA :
        <ol type="a">
          <li>Mengundurkan diri atas permintaan sendiri;</li>
          <li>Tidak masuk kerja selama 3 (tiga) hari secara berturut-turut tanpa keterangan yang sah;</li>
          <li>Tidak masuk kerja tidak berturut-turut selama 6 (enam) hari kerja tanpa keterangan yang sah dalam satu bulan;</li>
          <li>Meninggal dunia;</li>
          <li>Melanggar larangan sebagaimana berlaku pada Pegawai Negeri Sipil;</li>
          <li>Telah berusia 56 tahun;</li>
        </ol>
        </p>

        <h4 class="text-center">Pasal 9</h4>
        <p style="text-indent: 50px; text-align: justify;">
        Dalam melaksanakan Perjanjian Kontrak Kerja ini, PIHAK KEDUA tidak menuntut untuk menjadi Tenaga Kontrak Pemerintah Kabupten atau Calon Pegawai Negeri Sipil.
        </p>

        <h4 class="text-center">Pasal 10</h4>
        <p style="text-indent: 50px; text-align: justify;">
        Surat perjanjian kerja ini dibuat dalam ganda 2 (dua) bermaterai Rp. 6.000,- (enam ribu rupiah).<br>
        <table>
          <tr>
            <td width="170">Lembar pertama untuk</td>
            <td width="10">:</td>
            <td>PIHAK PERTAMA</td>
          </tr>
          <tr>
            <td>Lembar kedua untuk</td>
            <td>:</td>
            <td>PIHAK KEDUA</td>
          </tr>
        </table>
        </p>

        <br>
        <br>

        <div class="box" style="float: left;">
          <h4>PIHAK KEDUA</h4>
          <br><br><br><br>

          <h4><u>${this.selectedItem ? this.selectedItem.Employee.Name : ''}</u></h4>
        </div>

        <div class="box" style="float: right;">
          <h4>PIHAK KEDUA</h4>
          <h4>DIREKTUR RSUD Dr. SOEGIRI</h4>
          <h4>KABUPATEN LAMONGAN</h4>
          <br><br>

          <h4>
            <u>
              ${this.director.FrontDegree}
              ${this.director.Name}
              ${this.director.RearDegree}
            </u>
          </h4>
          <h4>${this.director.EmployeeClass.Alias}</h4>
          <h4>NIP. ${this.director.EmployeeIdNumber}</h4>
        </div>      
      `

      this.$nextTick(function () {

        const html = this.$constant.TEMPLATE_PRINT_HEADER + content + this.$constant.TEMPLATE_PRINT_FOOTER

        this.$refs.printFrame.srcdoc = html
      })

    },

    onPrint () {
      window.frames['printFrame'].print()
    }
  }
}
</script>
